// @ts-strict-ignore
import { JsonObject, JsonProperty } from '@shared/convert/convert-core';

@JsonObject('OrderConnectionInformationVO')
export class OrderConnectionInformationVO {

  @JsonProperty('orderNumber', 'Number')
  public orderNumber: number = undefined;
  @JsonProperty('articleNumber', 'String')
  public articleNumber: string = undefined;
  @JsonProperty('alternativeOrderConnectionNumber', 'Number')
  public alternativeOrderConnectionNumber: number = undefined;
}
